export const createDomain = (dataLength, colorsLength) => {
  if (dataLength <= 0 || colorsLength <= 1) {
    return [0]
  }

  const domain = [0]
  const toAdd = colorsLength - 1

  for (let i = 1; i < toAdd; i++) {
    domain.push(Math.floor(dataLength * (i / (colorsLength - 1))))
  }

  domain.push(dataLength - 1)
  return domain
}

export const getBatchColor = (batch, batches) => {
  const index = parseInt(batch.split('b')[1], 10) - 1

  return batches?.[index]?.color || ''
}

export const getUniqueContourPoints = (contour, imageHeight) => {
  return contour.reduce((arr, point) => {
    const newItem = [point.x, imageHeight - point.y]

    if (!arr.some(p => p[0] === newItem[0] && p[1] === newItem[1])) {
      arr.push(newItem)
    }

    return arr
  }, [])
}
